import { UPDATE_BUTTON_SAVE_STATUS, UPDATE_RULES_ASSET } from '../constants'
import { getAssetRules, loadNewRule, saveRules, setGlobalAlert, updateRule } from '.'
import convertUnits from './convertUnits'

export const onLoad = (dispatch, getState, setFiles, selectedUnitSet, sideview = false) => e => {
    try {
        const imported = JSON.parse(e.target.result)
        const { assetId, broadcastChannel, canEditGlobal, channel, localRules } = getState().editorReducer

        if (!imported.assetId) {
            dispatch(setGlobalAlert('Error importing: invalid file, missing asset ID', false))
        } else if (!imported.rules || !Array.isArray(imported.rules)) {
            dispatch(setGlobalAlert('Error importing: invalid format for rules property', false))
        } else if (channel && imported.rules.some(r => r.conditions?.[0]?.channel !== channel)) {
            dispatch(
                setGlobalAlert(
                    'Error importing: the main conditions of the rules must have the selected channel',
                    false
                )
            )
        } else {
            dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: true, button: 'import' } })

            const sameAsset = imported.assetId === assetId

            const rulesToSave = []

            if (sameAsset) {
                let newRulesCount = 0

                imported.rules.forEach(rule => {
                    // imported rule will overwrite current rule if the imported rule's id matches
                    // the id of the current rule at the same index
                    if (
                        rule.id &&
                        (rule.index || rule.index === 0) &&
                        !isNaN(parseInt(rule.index)) &&
                        rule.index >= 0 &&
                        rule.index <= localRules.length - 1 &&
                        localRules[rule.index].id === rule.id
                    ) {
                        rulesToSave.push({
                            ...rule,
                            // if we are "overwriting" a new rule (i.e.: not already saved),
                            // must unset its temporary id so that a new one is created
                            ...(rule.id.startsWith('NEW-') ? { id: undefined } : {})
                        })
                    } else {
                        rulesToSave.push({
                            ...rule,
                            id: undefined,
                            index: localRules.length + newRulesCount
                        })

                        newRulesCount++
                    }
                })
            } else {
                // all these rules are considered new, saved at the end of the list
                imported.rules.forEach((rule, idx) =>
                    rulesToSave.push({
                        ...rule,
                        id: undefined,
                        index: localRules.length + idx
                    })
                )
            }

            dispatch(
                saveRules(
                    [...rulesToSave.filter(r => !r.global)],
                    canEditGlobal ? [...rulesToSave.filter(r => r.global)] : [],
                    (result, newAndModifiedRules) => {
                        if (result !== 'error') {
                            newAndModifiedRules.forEach(rule =>
                                dispatch(
                                    rule.index >= localRules.length
                                        ? loadNewRule(rule)
                                        : updateRule(rule.index, rule, true)
                                )
                            )
                            dispatch(convertUnits(selectedUnitSet))

                            if (sideview) {
                                dispatch(getAssetRules(undefined, undefined, undefined, true))
                            } else {
                                broadcastChannel.postMessage({ type: UPDATE_RULES_ASSET, assetId })
                            }
                        }

                        dispatch({
                            type: UPDATE_BUTTON_SAVE_STATUS,
                            status: { saving: false, button: 'import' }
                        })
                        dispatch(
                            setGlobalAlert(
                                (result === 'success' ? 'Successfully imported' : 'Error importing') +
                                    ' alarm rule' +
                                    (imported.rules.length > 1 ? 's' : ''),
                                result === 'success'
                            )
                        )
                    }
                )
            )
        }
    } catch (err) {
        console.error('Error reading file:', err)
        dispatch(setGlobalAlert('Error importing file', false))
        dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: false, button: 'import' } })
    } finally {
        setFiles([])
    }
}

export default (event, setFiles, selectedUnitSet, sideview) => (dispatch, getState) => {
    const file = event.target.files?.[0]

    if (file) {
        const reader = new FileReader()

        reader.onload = onLoad(dispatch, getState, setFiles, selectedUnitSet, sideview)
        reader.readAsText(file)
    }
}
